import React from 'react'
import { graphql } from 'gatsby'
import MarkdownSection from '../components/MarkdownSection'
import SEO from '../components/SEO'

export default function Template({ data }) {
  const { markdownRemark } = data
  const { htmlAst, headings } = markdownRemark

  return (
    <>
      <SEO headings={headings} />
      <MarkdownSection htmlAst={htmlAst} />
    </>
  )
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(fields: { slug: { eq: $path } }) {
      fields {
        slug
      }
      headings(depth: h1) {
        value
      }
      htmlAst
    }
  }
`
